export enum GRADES {
  KINDERGARTEN = 'K',
  FIRST_GRADE = '1',
  SECOND_GRADE = '2',
  THIRD_GRADE = '3',
  FOURTH_GRADE = '4',
  FIFTH_GRADE = '5',
}
